import * as THREE from "three";
import { WORLD } from "../config";
import type { ClubMaterials } from "../materials";

export function buildPalm(mats: ClubMaterials, lean = 0.12): THREE.Group {
  const g = new THREE.Group();
  const segs = 7;
  let y = 0;
  for (let i = 0; i < segs; i++) {
    const h = 0.7 + i * 0.02;
    const r = 0.22 - i * 0.018;
    const trunk = new THREE.Mesh(new THREE.CylinderGeometry(r * 0.85, r, h, 8), mats.palmTrunk);
    trunk.position.set(lean * i * 0.15, y + h * 0.5, 0);
    trunk.rotation.z = -lean * 0.15;
    trunk.castShadow = true;
    g.add(trunk);
    y += h * 0.92;
  }

  const crownY = y + 0.15;
  const crownX = lean * segs * 0.14;
  const blade = new THREE.BoxGeometry(0.22, 0.045, 3.8);
  for (let i = 0; i < 12; i++) {
    const frond = new THREE.Mesh(blade, mats.frond);
    const a = (i / 12) * Math.PI * 2;
    frond.position.set(crownX + Math.cos(a) * 0.2, crownY, Math.sin(a) * 0.2);
    frond.rotation.set(-0.95, a, 0.12);
    frond.castShadow = true;
    g.add(frond);
  }
  return g;
}

export function plantPalms(mats: ClubMaterials): THREE.Group {
  const g = new THREE.Group();
  const spots: Array<[number, number, number]> = [
    [-18, 1.82, -38],
    [-12, 1.82, -52],
    [14, 1.82, -50],
    [22, 1.82, -36],
    [-32, 1.82, -42],
    [32, 1.82, -44],
    [-48, 1.82, -20],
    [50, 1.82, -8],
    [-52, 1.82, 16],
    [54, 1.82, 12],
    [-46, 1.82, 40],
    [48, 1.82, 38],
    [-10, 1.82, -58],
    [8, 1.82, -60],
    [-44, 1.82, -8],
    [44, 1.82, 6],
    [-44, 1.82, 22],
    [44, 1.82, 24],
  ];
  spots.forEach(([x, y, z], i) => {
    const palm = buildPalm(mats, 0.08 + (i % 5) * 0.03);
    palm.position.set(x, y, z);
    palm.rotation.y = i * 0.7;
    palm.scale.setScalar(0.85 + (i % 4) * 0.12);
    g.add(palm);
  });

  const terraceZ = WORLD.basinSouth - 14 + 8.2;
  for (const x of [-10, 10]) {
    const p = buildPalm(mats, 0.05);
    p.position.set(x, 2.4, terraceZ);
    p.scale.setScalar(0.55);
    g.add(p);
  }

  for (const [x, z] of [
    [-40, -34],
    [40, -34],
    [-36, -50],
    [36, -48],
  ] as const) {
    const bush = new THREE.Mesh(new THREE.SphereGeometry(1.1, 8, 6), mats.cushion);
    bush.position.set(x, 2.4, z);
    bush.scale.set(1.3, 0.85, 1.1);
    bush.castShadow = true;
    g.add(bush);
  }
  return g;
}
